/**
 * Init slider-products.
 */

export const sliderProducts = function() {
  const $slider = $('.js-slider-products');

  if ( ! $slider ){
    return;
  }

  $slider.slick({
    slidesToShow: 4,
    slidesToScroll: 4,
    appendArrows: '.slider__actions',
    prevArrow: '.slider__prev',
    nextArrow: '.slider__next',
    dots: true,
    appendDots: '.slider__dots',
    customPaging : function(slider, i) {
      let thumb = $(slider.$slides[i]).data();
      let slideNumber = ++i;

      return '<a>' + slideNumber + '</a>';
    },
    responsive: [
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        }    
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        }    
      }
    ]
  })
};

sliderProducts();
